module.exports = __webpack_public_path__ + "media/images/icons/icon-brain-ab7654a5362a688c2f7ce5a1fdbf20ca.svg";